import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { VegaFlex, VegaButtonLink, VegaPagination, VegaBox } from "@heartlandone/vega-react";
import { FILTER_CONTROL_CATEGORY, ROUTES_PATH, PAGINATION_OPTIONS, FILTER_OPTIONS } from 'Chore/Constants';
import { _fetch } from 'Chore/Request';
import { HubContext } from 'Redux/Context/context';
import { toggleGlobalModalAction, setGlobelActivitiesAction, setMyActivitiesAction } from 'Redux/Actions/actions';
import FilterGroup from 'Components/FilterGroup/FilterGroup';
import MainMenu from 'Components/MainMenu/MainMenu';
import ActivitySubMenu from './MyActivity/ActivitySubMenu/Index';
import { PATH } from 'Chore/Apis';

import './ActivityList/module.css';
import { debounce } from 'Chore/Utils';

const { GET_ACTIVITIES } = PATH;
const { GP_LIST } = PAGINATION_OPTIONS;
const DEFAULT_FILTER_PARAMS = {
  Keyword: '',
  Period: 'Last3Month',
  FeeType: 'All',
  PublisherCategory: '0',
  Status: 'All',
  IsFeedback: 'Registered',
  Category: 'Public',
};

const { PERIOD, PAYMENT, CATEGORY, STATUS } = FILTER_OPTIONS;

function ContentView() {
  const {
    globalModalDispatch,
    globalActivitiesDispatch,
    myActivitiesDispatch,
    reloadActivitiesState,
  } = useContext(HubContext);

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [header, setHeader] = useState('GP Activity List (0)');
  const [total, setTotal] = useState(0);
  const [keyword, setKeyword] = useState(DEFAULT_FILTER_PARAMS.Keyword);
  const [period, setPeriod] = useState(DEFAULT_FILTER_PARAMS.Period);
  const [feeType, setFeeType] = useState(DEFAULT_FILTER_PARAMS.FeeType);
  const [publisherCategory, setPublisherCategory] = useState(DEFAULT_FILTER_PARAMS.PublisherCategory);
  const [status, setStatus] = useState(DEFAULT_FILTER_PARAMS.Status);
  const [pageIndex, setPageIndex] = useState(1);
  const [category, setCategory] = useState('Public');
  const [subCategory, setSubCategory] = useState('Registered');

  const _isShow = () => !location.pathname.includes('activityInfo');

  useEffect(() => {
    resetFilter();
    if (location.pathname === ROUTES_PATH.ROOT) {
      setCategory('Public');
    } else if (location.pathname === ROUTES_PATH.MY_ACTIVITY) {
      setCategory('Registered');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    if(searchParams.has('category')){
      setCategory(searchParams.get('category'));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const _onFilterChange = (e, label) => {
    if (label === 'Period') {
      setPeriod(e.detail);
    } else if (label === 'FeeType') {
      setFeeType(e.detail)
    } else if(label === 'PublisherCategory'){
      setPublisherCategory(e.detail)
    } else if(label === 'Status'){
      setStatus(e.detail)
    }
  }

  const _onKeywordChange = (e) => {
    setKeyword(e.detail);
  }

  const debouncedOnChange = debounce(_onKeywordChange, 500);

  const updateHeaderTitle = (category, count) => {
    switch (category) {
      case "Public":
        setHeader(`GP Activity List (${count || 0})`);
        break;
      case "Registered":
        setHeader(`My Registration List`);
        break;
      case "Published":
        setHeader(`My Published Activity List`);
        break;
      case "Favorite":
        setHeader(`My Favorite Activity List`);
        break;
      default:
        setHeader(`GP Activity List (${count || 0})`);
    }
  };

  useEffect(() => {
    const params = {
      Category: category,
      PageIndex: pageIndex,
      Keyword: keyword,
      Period: period,
      FeeType: feeType,
      PublisherCategory: publisherCategory,
      PageSize: GP_LIST.SPAN,
    };
    if (category !== 'Registered') {
      params.Status = status;
    }
    if (category !== 'Public') {
      params.IsFeedback = subCategory;
    }
    updateHeaderTitle(category, 0);
    _loadActivity(params);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, subCategory, pageIndex, keyword, period, feeType, publisherCategory, status, reloadActivitiesState]);
      

  const _loadActivity = (params) => {
    if(params.Category === 'Public' && location.pathname !== ROUTES_PATH.ROOT) {
      return;
    }
    _toggleModal(true);
    _fetch({
      api: `${GET_ACTIVITIES}`,
      params : params
    }).then((res) => {
      if (location.pathname === ROUTES_PATH.MY_ACTIVITY) {
        myActivitiesDispatch(setMyActivitiesAction({ activities: res?.payload?.items || [], module: params.Category.toUpperCase(), subModule: params.IsFeedback }));
      } else {
        globalActivitiesDispatch(setGlobelActivitiesAction({ activities: res?.payload?.items || []}));
      }
      updateHeaderTitle(params.Category, res?.payload?.totalCount);
      setTotal(res?.payload?.totalCount || 0);
    }).finally(() => {
      _toggleModal();
    })
  }

  const _toggleModal = (isShow = false) => {
    globalModalDispatch(toggleGlobalModalAction({isShow}));
  }

  const OnAddActivityButtonClick = (e) => {
    e.preventDefault();
    navigate(ROUTES_PATH.ADD_ACTIVITY);
  }

  const _onPageIndexClick = (e) => {
    setPageIndex(e.detail);
  }

  const onSubMenuChange = (category) => {
    resetFilter();
    setCategory('Registered');
    setSubCategory(category);
  }

  const onMainMenuChange = (e) => {
    resetFilter();
    setCategory(e.detail)
    setSubCategory(DEFAULT_FILTER_PARAMS.IsFeedback);
    setSearchParams({
      ...searchParams,
      category: e.detail,
    });
  }

  const resetFilter = () => {
    setKeyword(DEFAULT_FILTER_PARAMS.Keyword);
    setPeriod(DEFAULT_FILTER_PARAMS.Period);
    setFeeType(DEFAULT_FILTER_PARAMS.FeeType);
    setPublisherCategory(DEFAULT_FILTER_PARAMS.PublisherCategory);
    setStatus(DEFAULT_FILTER_PARAMS.Status);
    setPageIndex(1);
    setCategory('');
  }

  return (
    <VegaFlex direction={'col'} style={{ width: '100%', minHeight: 'calc(100vh - 300px)'}}>
      {category !== 'Public' && location.pathname === ROUTES_PATH.MY_ACTIVITY && <MainMenu category={category} onChange={onMainMenuChange}></MainMenu>}
      <div className='bg-white p-24 round-12'>
        {
          !location.pathname.includes('activityInfo') && <>
            <VegaFlex className='m-b-24' justifyContent="space-between" alignItems="center">
              <h4 className='m-0 f-size-20 f-weight-700 font-normal line-height-28'>{header}</h4>
            </VegaFlex>
            <ActivitySubMenu onChange={onSubMenuChange}/>
            <VegaFlex className='m-b-24' justifyContent="space-between" alignItems="center">
              <FilterGroup options={[{
                type: FILTER_CONTROL_CATEGORY.INPUT,
                isRequired: false,
                placeholder: 'Search',
                onChangeHandler: (e) => debouncedOnChange(e),
                value: keyword
              }, {
                type: FILTER_CONTROL_CATEGORY.SELECT,
                isRequired: false,
                placeholder: '',
                source: PERIOD,
                onChangeHandler: (e) => _onFilterChange(e, 'Period'),
                value: period
              }, {
                type: FILTER_CONTROL_CATEGORY.SELECT,
                isRequired: false,
                placeholder: '',
                source: PAYMENT,
                onChangeHandler: (e) => _onFilterChange(e, 'FeeType'),
                value: feeType
              }, {
                type: FILTER_CONTROL_CATEGORY.SELECT,
                isRequired: false,
                placeholder: '',
                source: CATEGORY,
                onChangeHandler: (e) => _onFilterChange(e, 'PublisherCategory'),
                value: publisherCategory
              }, {
                type: (category !== 'Registered') && FILTER_CONTROL_CATEGORY.SELECT,
                isRequired: false,
                placeholder: '',
                source: STATUS,
                onChangeHandler: (e) => _onFilterChange(e, 'Status'),
                value: status
              }]}/>
              {
                location.pathname === ROUTES_PATH.ROOT &&  <VegaButtonLink 
                  label="Add New"
                  icon="far fa-plus"
                  onVegaClick={OnAddActivityButtonClick}
                />
              }
            </VegaFlex>
          </>
        }
        <Outlet/>
        <VegaBox className={`m-t-16${_isShow() ? "" : " display-none"}`}>
          <VegaPagination
            total={total}
            pageSize={GP_LIST.SPAN}
            current={pageIndex}
            extensions={[
              ["currentPageLabel"],
              ["pageSelector", "goTo"],
            ]}
            onVegaChange={_onPageIndexClick}
          />
        </VegaBox>
      </div>
    </VegaFlex>
  );
}

export default ContentView;
